import {
  chakra,
  ComponentWithAs,
  HTMLChakraProps,
  ThemeTypings,
  useMultiStyleConfig,
} from '@chakra-ui/system';

import SunshineIcon, { IconName as SunshineIconName } from '../SunshineIcon';
import Button from './components/Button';
import Content from './components/Content';
import Title from './components/Title';
import { COMPONENT_NAME, StylesProvider } from './context';

type Variant = ThemeTypings['components']['Callout']['variants'];

const iconsRebrandedMap: Record<Variant, SunshineIconName> = {
  error: 'warning',
  info: 'information',
  warning: 'warning',
};

interface CalloutParts {
  Button: typeof Button;
  Content: typeof Content;
  Title: typeof Title;
}

export interface CalloutProps extends HTMLChakraProps<'div'> {
  hideIcon?: boolean;
  variant?: Variant;
}

type CalloutType = ComponentWithAs<'div', CalloutProps> & CalloutParts;

/**
 * https://www.figma.com/file/NDYFGMfDaxqqY41C55RDgl/%F0%9F%90%A5-NEW-DESIGN-SYSTEM?node-id=8468%3A42058&t=BMXlpcFDV83xIao0-1
 */
const Callout: CalloutType = ({
  children,
  hideIcon = false,
  variant = 'info',
  ...props
}) => {
  const styles = useMultiStyleConfig(COMPONENT_NAME, { variant });

  return (
    <chakra.div __css={styles.container} {...props}>
      {hideIcon ? null : (
        <chakra.div __css={styles.iconContainer}>
          <chakra.div
            __css={styles.icon}
            as={SunshineIcon}
            name={iconsRebrandedMap[variant]}
            size="icon-15"
          />
        </chakra.div>
      )}

      <StylesProvider value={styles}>{children}</StylesProvider>
    </chakra.div>
  );
};

Callout.Button = Button;
Callout.Content = Content;
Callout.Title = Title;

export default Callout;
